import { render } from "./ProfileHeader.vue?vue&type=template&id=dd8907bc"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=dd8907bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__